module.exports = __webpack_public_path__ + "img/monitorbox21.a93e8cfe.jpg";